import React, { useRef, useState, useEffect } from "react";

import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import Pagination from "../../components/Pagination";
import ReactFileReader from "react-file-reader";
import { utils, read } from "xlsx";
import moment from "moment";

const FarmerUpload = (props) => {
  const frmRef = useRef({});
  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();
  const [attachmentUrl, setAttachmentUrl] = useState();

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  );

  const { sendRequest: postAddVendor } = useHttp();

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const { sendRequest: getExistingFarmers } = useHttp();
  const [existingFarmerNos, setExistingFarmerNos] = useState([]);
  const [hasExistingFarmers, setHasExistingFarmers] = useState(false);

  const [areaData, setAreaData] = useState([]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData = utils.sheet_to_json(worksheet, { header: 1 });

    var count = parsedData.length;
    var newList = [];
    const now = new Date();
    const secondsSinceEpoch = Math.round(now.getTime() / 1000);

    for (var k = 1; k < count - 1; k++) {
      var item = parsedData[k];
      if (item[0] != "") {
        var liveStock = false;

        if ((item[3] ?? "") != "") {
          var regionId = 0;
          var areaId = 0;
          var fieldExecutiveId = 0;
          var fieldExecutiveEmail = item[0].trim();
          var regionName = item[1];
          var areaName = item[37].trim();

          var otherShares = false;
          if (item[30].toString().trim() != "Yes") {
            otherShares = true;
          }

          var regionlist = regionData.filter(
            (item1) => item1.regionName.trim() == regionName.trim()
          );
          if (regionlist && regionlist.length > 0) {
            regionId = regionlist[0].regionId;
          }

          var arealist = areaData.filter((item1) => item1.areaName == areaName);
          if (arealist && arealist.length > 0) {
            areaId = arealist[0].areaId;
          }

          var employeelist = employeeData.filter(
            (item1) => (item1.emailId ?? "") == fieldExecutiveEmail
          );
          if (employeelist && employeelist.length > 0) {
            fieldExecutiveId = employeelist[0].userId;
          }

          var farmerId = secondsSinceEpoch.toString().concat(k.toString());

          newList = newList.concat({
            srNo: k,
            farmerId: farmerId,
            fieldExecutiveEmail: (item[0] ?? "").toString().trim(),
            fieldExecutiveId: fieldExecutiveId,
            createdBy: fieldExecutiveId,
            regionName: (item[1] ?? "").toString().trim(),
            regionId: regionId,
            registrationDate: JSON.parse(
              (item[2] ?? "")
                .toString()
                .replaceAll(/“/g, "")
                .replaceAll(/”/g, "")
                .trim() || null
            ),
            farmerName: (item[3] ?? "").toString().trim(),
            status: 1,
            identificationNo: (item[4] ?? "").toString().trim(),
            gender: (item[5] ?? "").toString().trim(),
            dob: (item[6] ?? "")
              .toString()
              .replaceAll(/“/g, "")
              .replaceAll(/”/g, "")
              .trim(),
            mobile: (item[7] ?? "").toString().trim(),
            email: (item[8] ?? "").toString().trim(),
            address: (item[9] ?? "").toString().trim(),
            farmerEducation: (item[10] ?? "").toString().trim(),
            pinCode: (item[11] ?? "").toString().trim(),
            city: (item[12] ?? "").toString().trim(),
            state: (item[13] ?? "").toString().trim(),
            country: (item[14] ?? "").toString().trim(),
            isliveStockAvailable: (item[15] ?? "").toString().trim(),
            liveStock: liveStock,
            idProof: (item[16] ?? "").toString().trim(),
            totalLand: (item[17] ?? "").toString().trim(),
            totalLandUnit: (item[18] ?? "").toString().trim(),
            farmerGroup: (item[19] ?? "").toString().trim(),
            institute: (item[20] ?? "").toString().trim(),
            caste: (item[21] ?? "").toString().trim(),
            farmerIncome: item[22] ?? "",
            typeOfLandOwnership: (item[23] ?? "").toString().trim(),
            typeOfFarming: (item[24] ?? "").toString().trim(),
            farmerOtherIncome: (item[25] ?? "").toString().trim(),
            farmerGoal: (item[26] ?? "").toString().trim(),
            fpoCertificate: (item[27] ?? "").toString().trim(),
            fpoCertificateQuantity: (item[28] ?? "").toString().trim(),
            fpoCertificateAmount: (item[29] ?? "").toString().trim(),
            otherSharesYesNo: (item[30] ?? "").toString().trim(),
            otherShares: (item[30] ?? "").toString().trim(),
            otherSharesQuantity: (item[31] ?? "").toString().trim(),
            accountNumber: (item[32] ?? "").toString().trim(),
            accountHolderName: (item[33] ?? "").toString().trim(),
            ifscCode: (item[34] ?? "").toString().trim(),
            training: (item[35] ?? "").toString().trim(),
            warehouseName: (item[36] ?? "").toString().trim(),
            areaId: areaId,
            farmerGrowthType: (item[38] ?? "").toString().trim(),
            farmerStatus: (item[39] ?? "").toString().trim(),
            orgId: (localStorage.getItem("orgId") ?? "").toString().trim(),
            crops: (item[40] ?? "").toString().trim(),
            baselineIncome: (item[41] ?? "").toString().trim(),
            householdSize: (item[42] ?? "").toString().trim(),
            estimatedYieldKg: (item[43] ?? "").toString().trim(),
            nin: (item[44] ?? "").toString().trim(),
            baseIncomeSource: (item[45] ?? "").toString().trim(),
            bvn: (item[46] ?? "").toString().trim(),
            commitmentFeePayment: (item[47] ?? "").toString().trim(),
            farmerNo: (item[48] ?? "").toString().trim(),
            createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          });
        }
      }
    }

    // Now check duplicates inside uploaded file + DB
    const seen = new Set();
    let existingFound = false;

    const checkedList = newList.map((row) => {
      const farmerNo = (row.farmerNo ?? "").toString().trim();

      if (!farmerNo) {
        return { ...row, error: "Farmer No missing", errorType: "missing" };
      }

      if (seen.has(farmerNo)) {
        return {
          ...row,
          error: "Duplicate Farmer No in uploaded file",
          errorType: "duplicate",
        };
      }

      if (existingFarmerNos.includes(farmerNo)) {
        existingFound = true;
        return {
          ...row,
          error: "Farmer No already exists in system",
          errorType: "existing",
        };
      }

      seen.add(farmerNo); 
      return { ...row, error: null, errorType: null };
    });

    setData(checkedList);
    setHasExistingFarmers(existingFound);
  };

  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const invalid = data.filter((d) => d.error);
    if (invalid.length > 0) {
      toast.error(
        "Duplicate or existing Farmer Nos found. Please fix before uploading."
      );
      return;
    }

    postAddVendor(
      {
        url: "/api/uploadFarmer/",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`farmer data uploaded`);
        setData([]);
      }
    );
  };

  const { sendRequest: getArea } = useHttp();

  useEffect(() => {
    getArea(
      {
        url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setAreaData(data.data);
      }
    );
  }, [getArea]);

  const { sendRequest: getRegion } = useHttp();

  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.data);
      }
    );
  }, [getEmp]);

  useEffect(() => {
    getExistingFarmers(
      {
        url: `/api/farmerNumberForUploadList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        const farmerNos = data.map((f) => (f.farmerNo ?? "").toString().trim());
        setExistingFarmerNos(farmerNos);
      }
    );
  }, [getExistingFarmers]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                &nbsp;
                <div className="card">
                  <div className="card-body">
                    <div className="row"> </div>
                    <div className="row">
                      <div className="col-4">
                        <label className="card-title mx-2 my-3 ">
                          Farmer Details
                        </label>
                      </div>
                      <div className="col-4"> </div>
                      <div className="col-2"> </div>
                      <div className="col-2">
                        <ReactFileReader
                          handleFiles={handleFileUpload}
                          fileTypes={".xlsx"}
                        >
                          <button
                            type="button"
                            className="btn  btn-primary mx-2 my-2"
                          >
                            Upload Excel
                          </button>
                        </ReactFileReader>{" "}
                      </div>
                    </div>
                    {/* {hasExistingFarmers && (
                      <div className="alert alert-warning m-3">
                        Some Farmer Numbers already exist in the system. They
                        are highlighted in{" "}
                        <span className="text-primary fw-bold">blue</span>.
                      </div>
                    )} */}

                    <div className="row">
                      <table className="table table-bordered table-responsive text-center table-sm">
                        <thead>
                          <tr>
                            <th>Farmer No</th>
                            <th>Field Executive Email</th>
                            <th>Region Name</th>
                            <th>Registration Date</th>
                            <th>Farmer Name</th>
                            <th>Gender</th>
                            <th>Dob</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th>Farmer Education</th>
                            <th>PinCode</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Country</th>
                            <th>Is Live Stock Available</th>
                            <th>Id Proof</th>
                            <th>Total Land</th>
                            <th>Total Land Unit</th>
                            <th>Farmer Group</th>
                            <th>Institute</th>
                            <th>Caste</th>
                            <th>Farmer Income</th>
                            <th>Type Of Land Ownership</th>
                            <th>Type Of Farming Farmer</th>
                            <th>Other Income</th>
                            <th>Farmer Goal</th>
                            <th>FPO Certificate</th>
                            <th>FPO Certificate Quantity</th>
                            <th>FPO Certificate Amount</th>
                            <th>Other Shares</th>
                            <th>Other Shares Quantity</th>
                            <th>Account Number</th>
                            <th>Account Holder Name</th>
                            <th>IFSC Code</th>
                            <th>Training</th>
                            <th>Warehouse Name</th>
                            <th>Area</th>
                            <th>Farmer Growth Type</th>
                            <th>Farmer Status</th>
                            <th>Crops</th>
                            <th>Baseline Income</th>
                            <th>Householdsize</th>
                            <th>EstimatedYeildSize</th>
                            <th>NIN</th>
                            <th>Base Income Source</th>
                            <th>BVN</th>
                            <th>Commitment Fee Payment</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr
                                key={i}
                                className={
                                  x.errorType === "duplicate" ||
                                  x.errorType === "missing"
                                    ? "text-danger" // red for file issues
                                    : x.errorType === "existing"
                                    ? "text-primary" // blue for system existing
                                    : ""
                                }
                              >
                                <td>{x.farmerNo}</td>
                                <td>{x.fieldExecutiveEmail}</td>
                                <td>{x.regionName}</td>
                                <td>{x.registrationDate}</td>
                                <td>{x.farmerName}</td>
                                <td>{x.gender}</td>
                                <td>{x.dob}</td>
                                <td>{x.mobile}</td>
                                <td>{x.email}</td>
                                <td>{x.address}</td>
                                <td>{x.farmerEducation}</td>
                                <td>{x.pinCode}</td>
                                <td>{x.city}</td>
                                <td>{x.state}</td>
                                <td>{x.country}</td>
                                <td>{x.isliveStockAvailable}</td>
                                <td>{x.idProof}</td>
                                <td>{x.totalLand}</td>
                                <td>{x.totalLandUnit}</td>
                                <td>{x.farmerGroup}</td>
                                <td>{x.institute}</td>
                                <td>{x.caste}</td>
                                <td>{x.farmerIncome}</td>
                                <td>{x.typeOfLandOwnership}</td>
                                <td>{x.typeOfFarming}</td>
                                <td>{x.farmerOtherIncome}</td>
                                <td>{x.farmerGoal}</td>
                                <td>{x.fpoCertificate}</td>
                                <td>{x.fpoCertificateQuantity}</td>
                                <td>{x.fpoCertificateAmount}</td>
                                <td>{x.otherShares}</td>
                                <td>{x.otherSharesQuantity}</td>
                                <td>{x.accountNumber}</td>
                                <td>{x.accountHolderName}</td>
                                <td>{x.ifscCode}</td>
                                <td>{x.training}</td>
                                <td>{x.warehouseName}</td>
                                <td>{x.areaId}</td>
                                <td>{x.farmerGrowthType}</td>
                                <td>{x.farmerStatus}</td>
                                <td>{x.crops}</td>
                                <td>{x.baselineIncome}</td>
                                <td>{x.householdSize}</td>
                                <td>{x.estimatedYieldKg}</td>
                                <td>{x.nin}</td>
                                <td>{x.baseIncomeSource}</td>
                                <td>{x.bvn}</td>
                                <td>{x.commitmentFeePayment}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                  <div>
                    {data.some((d) => d.error) && (
                      <div className="m-4">
                        <h6 className="fw-bold text-danger mb-0 mx-3">
                          Duplicate or Empty Farmer No found in uploaded file
                          (mentioned in red color & Existed No color Is Blue)
                        </h6>
                      </div>
                    )}

                    {hasExistingFarmers && (
                      <div className="m-4">
                        <h6 className="fw-bold text-primary mb-0 mx-3">
                          Some Farmer Numbers already exist in the system. They
                          are highlighted in blue color
                        </h6>
                      </div>
                    )}
                  </div>

                  {!data.some((d) => d.error) && (
                    <div className="row">
                      <div className="col-md-4"></div>
                      <div className="col-md-4 d-flex justify-content-center">
                        <button
                          className="btn btn-primary mx-2 my-2"
                          type="submit"
                          onClick={(e) => submitHandler(e)}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-md-4"></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerUpload;
